import {Subject} from 'rxjs';

export class FetchPerpetualLicenses {
    public static readonly type = '[Perpetual Licenses] FetchPerpetualLicenses';

    constructor(public accountId: number, public cancellationToken?: Subject<any>) {
    }

}
